import React from 'react';
import { Link } from 'react-router-dom';

const EmailService = () => {
  return (
    <section id="email-service" className="py-16 bg-gradient-to-br from-purple-600 to-indigo-800">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            INFINITY EMAILPRO
          </h2>
          <p className="text-purple-100 text-lg max-w-3xl mx-auto">
            Infinity Emailpro is a simple, reliable & professional email delivery service that helps you reach your customers instantly with a powerful email marketing and transactional email platform designed for African businesses.
          </p>
        </div>

        {/* Email Service Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/services/EmailService.png" 
                alt="Email Service Integration" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-indigo-600 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                <span className="animate-pulse mr-2">✉️</span> SIMPLE & RELIABLE
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Send Emails & Manage Subscriptions Effortlessly
              </h3>
              <p className="text-indigo-600 font-semibold mb-4 text-lg">
                A simple, reliable, and affordable email service for African businesses.
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                With Infinity Emailpro, you can communicate with your customers through professional email delivery for individual messages, automated order confirmations, or large-scale campaigns. No tech skills needed. Just log in, send, and track. And with convenient M-PESA payments, subscribing to our plans is as easy as sending an SMS.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">WHY CHOOSE INFINITY EMAILPRO</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>For Easy Bulk Email Sending</strong> - Infinity Emailpro streamlines sending of individual or bulk campaigns in just a few clicks.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Flexible Subscription Plans</strong> - Choose a plan that grows with your business.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Convenient M-PESA Payments</strong> - Instant activation after payment.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Easy Tracking</strong> - Monitor open rates, clicks, and transaction history with ease.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-indigo-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>No Coding Needed</strong> - A user-friendly platform that anyone can use.</span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">INFINITY EMAILPRO IS PERFECT FOR:</h4>
                <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-4 border border-indigo-100">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Welcome emails & onboarding new customers</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Order confirmations, receipts & invoices</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Marketing newsletters & promotions</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Business announcements & updates</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>SMEs, startups, entrepreneurs, and NGOs</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6 bg-blue-50 rounded-lg p-4 border border-blue-200">
  <h4 className="font-bold text-blue-800 mb-3">Simple Pricing Plans:</h4>
  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div className="bg-white p-3 rounded border">
      <h5 className="font-semibold text-blue-700">Tier 1</h5>
      <p className="text-gray-600 text-sm">1 - 1,000 emails</p>
      <p className="text-gray-800 font-bold">KES 1 per email</p>
      <p className="text-gray-500 text-xs">Total: KES 1,000</p>
    </div>
    <div className="bg-white p-3 rounded border">
      <h5 className="font-semibold text-blue-700">Tier 2</h5>
      <p className="text-gray-600 text-sm">1,001 - 10,000 emails</p>
      <p className="text-gray-800 font-bold">KES 0.8 per email</p>
      <p className="text-gray-500 text-xs">Total: KES 8,000</p>
    </div>
    <div className="bg-white p-3 rounded border">
      <h5 className="font-semibold text-blue-700">Tier 3</h5>
      <p className="text-gray-600 text-sm">10,001 - 100,000 emails</p>
      <p className="text-gray-800 font-bold">KES 0.6 per email</p>
      <p className="text-gray-500 text-xs">Total: KES 60,000</p>
    </div>
    <div className="bg-white p-3 rounded border">
      <h5 className="font-semibold text-blue-700">Tier 4</h5>
      <p className="text-gray-600 text-sm">100,001 - 500,000 emails</p>
      <p className="text-gray-800 font-bold">KES 0.5 per email</p>
      <p className="text-gray-500 text-xs">Total: KES 250,000</p>
    </div>
    <div className="bg-white p-3 rounded border">
      <h5 className="font-semibold text-blue-700">Tier 5</h5>
      <p className="text-gray-600 text-sm">500,001 - 1,000,000 emails</p>
      <p className="text-gray-800 font-bold">KES 0.4 per email</p>
      <p className="text-gray-500 text-xs">Total: KES 400,000</p>
    </div>
    <div className="bg-white p-3 rounded border">
      <h5 className="font-semibold text-blue-700">Tier 6</h5>
      <p className="text-gray-600 text-sm">1,000,001+ emails</p>
      <p className="text-gray-800 font-bold">KES 0.3 per email</p>
      <p className="text-gray-500 text-xs">Total: KES 300,000</p>
    </div>
  </div>
</div>

              <p className="text-indigo-600 font-semibold mb-6 text-center text-lg flex justify-center items-center">
                <span className="mr-2">Start sending professional emails today with our affordable plans!</span>
                <span className="text-2xl">✉️</span>
              </p>

              <Link
                to="https://emailpro.infinitytechafrica.com/signup"
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Launch Your Emailpro Now</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Simplify Your Email Communication?
            </h3>
            <p className="text-purple-100 mb-6 text-lg">
              Join businesses that use our straightforward bulk email service with convenient M-PESA payments.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Our Team
              </a>
              {/* <a
                href="/contact"
                className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Us
              </a> */}
              
            </div>
            <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa. Create. Transform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailService;
